import React, { useState } from "react";
import { NewInput } from "../..";
import { LocaleFarmDate, NewFieldStyles, NewFieldTypes } from "../../../Definitions";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
import { IdentifiableRow } from "../reactiveTableRenderer";
import { CellContext } from "@tanstack/react-table";
import { focus_view } from "../../../Assets/Glyphs/focusView";

export const DateTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, cell, focus_view}: CellContext<T, Date| undefined> & EditAbleCell) => {
  const initialValue = getValue();

  const [value, setValue] = useState(initialValue);

  const onBlur = () => {
    if (value !==initialValue) {
      table.options.meta?.updateData(row.original.id, column.id, value?.getTime(), row);
    }
  }

  return <StyledDateCell staticColumn={staticColumn} key={cell.id} keyPass={cell.id+"Input"} onBlur={onBlur} onChange={(e: string) => setValue(new Date(e))} canEdit={canEdit} cellData={{value}} focus_view={focus_view} />
}

const StyledDateCell = ({onBlur, onChange, canEdit, cellData, keyPass, staticColumn, focus_view}: StyledTableCellProps & EditAbleCell) => {
  
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 0.5  }} key={keyPass}>
          {new LocaleFarmDate(cellData.value).toLocaleFarmString() ?? ''}
        </div>
      );
    } else {
      return (
        <NewInput
          onBlur={onBlur}
          key={keyPass}
          onChange={onChange}
          fieldOverrides={{
            fieldStyle: NewFieldStyles.greyTertiary,
            fieldType: NewFieldTypes.tertiaryField,
            fieldWidth: "100%",
            focus_view: focus_view
          }}
          valueOverrides={{
            defaultValue: new LocaleFarmDate(cellData.value).toDateForInput(),
            valueType: "string"
          }}
        />
      );
    }
  }

  return (new LocaleFarmDate(cellData.value).toLocaleFarmString());

}